<form #skuForm="ngForm">

  <rms-mod width="100%" height="auto">

    <div class="update-toolbar">
      <label class="select-skus"><input type="checkbox" [checked]="allSelected" [indeterminate]="selectedSKUs.length > 0 && !allSelected" [disabled]="saving" (change)="selectAll($any($event.target).checked)"> {{ selectedSKUs.length }} SKUs selected</label>
      <button type="button" mat-button class="btn-bg-red" [disabled]="saving" (click)="cancel()">Cancel</button>
      @if(SKUsToUpdate.length > 1){
      <button type="button" mat-button class="btn-bg-blue" [disabled]="saving || !selectedSKUs.length" (click)="CopySKUToAll()">
        <mat-icon>content_copy</mat-icon>
        Copy First Selected SKU
      </button>
      }

      <span class="spacer"></span>

      <button type="button" mat-button
              class="btn-bg-green"
              [disabled]="!canSave"
              (click)="savePrices()">
        <mat-icon>save</mat-icon>
        {{ saving ? 'Saving…' : 'Update Selected SKUs' }}
      </button>

      <span class="spacer"></span>

      <button type="button" mat-button
              [disabled]="saving"
              (click)="ApplyPreviousPricing()"
              class="btn-bg-yellow">
        Apply Previous To Selected
      </button>

      @if (remainingSKUs > 0) {
      <div class="pricing-warning">
        {{ remainingSKUs }} SKU(s) still require pricing updates.
      </div>
      }

    </div>

    @for (sku of SKUsToUpdate; track sku.InventoryTypeID; let firstRow = $first) {

    <div class="sku-update-card" [class.saving]="saving" [attr.inert]="saving ? '' : null">

      <div class="card-header">
        <div class="sku-name-row">
          <input type="checkbox" [name]="'SelectedSKU' + sku.InventoryTypeID" [ngModel]="sku.PricingSelected" (ngModelChange)="selectSku(sku, $event)" [attr.aria-label]="'Select ' + sku.InventoryTypeName" [disabled]="saving">
          <div class="sku-name" [title]="sku.InventoryTypeName">{{sku.InventoryTypeName}}</div>
          @if(SKUsToUpdate.length > 1){<button tabindex="-1" type="button" mat-icon-button (click)="CopySKUToAll(sku)" title="Copy this SKU to selected SKUs" aria-label="Copy this SKU to selected SKUs"><mat-icon>content_copy</mat-icon></button>}
          <button tabindex="-1" type="button" mat-icon-button (click)="ApplyPreviousPricing(sku)" title="Apply previous pricing" aria-label="Apply previous pricing"><mat-icon>settings_backup_restore</mat-icon></button>
          
        </div>
        <div class="sku-stats"><span>Spot <strong>{{sku.TotalAvailableQty | number:'1.0-0'}}</strong> · Aged <strong>{{sku.SpotCostDetail}}</strong></span><span>FWD <strong>{{sku.TotalForwardQty | number:'1.0-0'}}</strong> · Landed <strong>{{sku.ForwardCostDetail}}</strong></span></div>
        <div class="suggested-pricing">Suggested <strong>{{sku.SuggestedPriceDisplay}}</strong><button tabindex="-1" type="button" mat-icon-button (click)="openSKUHistory(sku)" title="View pricing history" aria-label="View pricing history"><mat-icon>restore</mat-icon></button></div>
      </div>

      <div class="pricing-grid">

        <div class="input-container">

          <rms-input [name]="'ReplaceFixed' + sku.InventoryTypeID"
                     label="Replace Fixed"
                     type="currency" decimalFormat="1.2-2" rounding="ceil" [roundOnBlur]="true" [clearZeroOnFocus]="true"
                     [(ngModel)]="sku.pricing.ReplacementFixed"
                     (ngModelChange)="markSkuUpdated(sku)">
          </rms-input>
          @if(firstRow && SKUsToUpdate.length > 1){<button tabindex="-1" type="button" mat-button class="copy-field" title="Copy this field to selected SKUs" [disabled]="saving" (click)="CopyFieldToAll(sku, 'ReplacementFixed')" aria-label="Copy replacement fixed from this SKU to selected SKUs"><mat-icon>content_copy</mat-icon></button>}

          <div class="input-footer">
            Last:
            <strong>{{ sku.AverageHistoricalReplacementFixedDisplay }}</strong>
          </div>

        </div>

        <div class="input-container">

          <rms-input [name]="'ReplaceDiff' + sku.InventoryTypeID"
                     label="Replace Diff"
                     type="decimal" decimalFormat="1.2-2" rounding="ceil" [roundOnBlur]="true" [clearZeroOnFocus]="true"
                     [(ngModel)]="sku.pricing.ReplacementDiff"
                     (ngModelChange)="markSkuUpdated(sku)">
          </rms-input>
          @if(firstRow && SKUsToUpdate.length > 1){<button tabindex="-1" type="button" mat-button class="copy-field" [disabled]="saving" (click)="CopyFieldToAll(sku, 'ReplacementDiff')" aria-label="Copy replacement diff from this SKU to all selected SKUs"><mat-icon>content_copy</mat-icon></button>}

          <!--<div class="input-footer">
            Last:
            <strong>{{ sku.AverageHistoricalReplacementDiffDisplay }}</strong>
          </div>-->

        </div>

        <div class="input-container">

          <rms-input [name]="'AskFixed' + sku.InventoryTypeID"
                     label="Ask Fixed"
                     type="currency" decimalFormat="1.2-2" rounding="ceil" [roundOnBlur]="true" [clearZeroOnFocus]="true"
                     [(ngModel)]="sku.pricing.AskPriceFixed"
                     (ngModelChange)="markSkuUpdated(sku)">
          </rms-input>
          @if(firstRow && SKUsToUpdate.length > 1){<button tabindex="-1" type="button" mat-button class="copy-field" [disabled]="saving" (click)="CopyFieldToAll(sku, 'AskPriceFixed')" aria-label="Copy ask fixed from this SKU to all selected SKUs"><mat-icon>content_copy</mat-icon></button>}

          <!--<div class="input-footer">
            Last:
            <strong>{{ sku.AverageLatestAskFixedDisplay }}</strong>
          </div>-->

        </div>

        <div class="input-container">

          <rms-input [name]="'AskDiff' + sku.InventoryTypeID"
                     label="Ask Diff"
                     type="decimal" decimalFormat="1.2-2" rounding="ceil" [roundOnBlur]="true" [clearZeroOnFocus]="true"
                     [(ngModel)]="sku.pricing.AskPriceDiff"
                     (ngModelChange)="markSkuUpdated(sku)">
          </rms-input>
          @if(firstRow && SKUsToUpdate.length > 1){<button tabindex="-1" type="button" mat-button class="copy-field" [disabled]="saving" (click)="CopyFieldToAll(sku, 'AskPriceDiff')" aria-label="Copy ask diff from this SKU to all selected SKUs"><mat-icon>content_copy</mat-icon></button>}

          <!--<div class="input-footer">
            Last:
            <strong>{{ sku.AverageLatestAskDiffDisplay }}</strong>
          </div>-->

        </div>

        <div class="input-container"><rms-input [name]="'CurrentMarketPrice' + sku.InventoryTypeID"
                   label="'C' Market"
                   type="currency" decimalFormat="1.2-2" rounding="ceil" [roundOnBlur]="true" [clearZeroOnFocus]="true"
                   [(ngModel)]="sku.pricing.CurrentMarketPrice"
                   (ngModelChange)="markSkuUpdated(sku)">
        </rms-input>
          @if(firstRow && SKUsToUpdate.length > 1){<button tabindex="-1" type="button" mat-button class="copy-field" [disabled]="saving" (click)="CopyFieldToAll(sku, 'CurrentMarketPrice')" aria-label="Copy market price from this SKU to all selected SKUs"><mat-icon>content_copy</mat-icon></button>}<div class="input-footer field-copy-spacer" aria-hidden="true">&nbsp;</div></div>

        <div class="input-container notes-field"><rms-textarea [name]="'Notes' + sku.InventoryTypeID"
                      label="Notes"
                      [includePopout]="true" [popoutTabIndex]="-1"
                      [ngModel]="sku.NotesEdited ? sku.pricing.Comments : ''"
                      [placeholder]="sku.NotesEdited ? '' : sku.pricing.Comments"
                      (ngModelChange)="updateNotes(sku, $event)">
        </rms-textarea>
          @if(firstRow && SKUsToUpdate.length > 1){<button tabindex="-1" type="button" mat-button class="copy-field" [disabled]="saving" (click)="CopyFieldToAll(sku, 'Comments')" aria-label="Copy notes from this SKU to all selected SKUs"><mat-icon>content_copy</mat-icon></button>}<div class="input-footer field-copy-spacer" aria-hidden="true">&nbsp;</div></div>

        <button tabindex="-1" type="button" mat-icon-button class="btn-bg-green sku-save-button" [disabled]="!canSaveSku(sku)" [attr.aria-label]="'Update only ' + sku.InventoryTypeName" title="Update only this SKU" (click)="savePrices(sku)"><mat-icon>save</mat-icon></button>
      </div>

    </div>

    }

  </rms-mod>

</form>
